import { DataType } from '@/util/index'

const BANK = {
  section: {
    name: 'bank',
    caption: 'BANK INFO',
    type: 'form',
    code: DataType.PrivilegeCode.BANK_INFO_SECTION,
    stamp: 'bankingStamp'
  },
  questionGroup: 1,
  metadata: [
    { name: 'questionType', value: 1 }
  ],
  title: {
    template: '{bankName}',
    case: 'PROPER_CASE',
    fieldKey: 'bankName'
  },
  stampVerifications: [
    { sectionKey: DataType.LoanSectionKey.BANKING, actionType: DataType.StampActionTypeEnum.POSITIVE_STAMP.value, text: DataType.StampActionTypeEnum.POSITIVE_STAMP.text, icon: 'check_circle', color: 'success', class: 'm-0 m-l-10' },
    { sectionKey: DataType.LoanSectionKey.BANKING, actionType: DataType.StampActionTypeEnum.PENDING_STAMP.value, text: DataType.StampActionTypeEnum.PENDING_STAMP.text, icon: 'pending', color: 'warning', class: 'm-0' },
    { sectionKey: DataType.LoanSectionKey.BANKING, actionType: DataType.StampActionTypeEnum.NEGATIVE_STAMP.value, text: DataType.StampActionTypeEnum.NEGATIVE_STAMP.text, icon: 'cancel', color: 'error', class: 'm-0' }
  ],
  sectionFields: [
    { label: 'Routing #', template: '{routingNo}', fieldKey: 'routingNo', hasBlacklistTip: true, blackListFieldKey: 'routingNo' },
    { label: 'Account #', template: '{accountNo}', fieldKey: 'accountNo', isHidePll: true, hasBlacklistTip: true, blackListFieldKey: 'accountNo' },
    { label: 'Account Type', template: '{accountType}', fieldKey: 'accountType', options: { accountType: DataType.BankAccountType } },
    { label: 'Bank Phone', template: '{bankPhone}', fieldKey: 'bankPhone', format: 'phone' },
    { label: '$ of Open Loans', template: '{amountOfOpenLoans}', fieldKey: 'amountOfOpenLoans', format: 'currency' },
    { label: '# of Open Loans', template: '{numberOfOpenLoans}', fieldKey: 'numberOfOpenLoans' },
    { label: 'Account Balance', template: '{accountBalance}', fieldKey: 'accountBalance', format: 'currency' }
  ],
  formFields: [
    { label: 'Bank Name', fieldKey: 'bankName', class: 'lg12', rules: 'required|specialCharacters' },
    { label: 'Routing #', fieldKey: 'routingNo', mask: '#########', rules: 'required|bankRoutingNo' },
    { label: 'Account #', fieldKey: 'accountNo', rules: 'required|bankAccountNo' },
    // { label: 'Account #', fieldKey: 'accountNo', rules: 'required|bankAccountNo|blackList:accountNo' },
    { label: 'Account Type', fieldKey: 'accountType', controlType: 'v-select', options: { accountType: DataType.BankAccountType }, rules: 'required' },
    { label: 'Bank Phone', fieldKey: 'bankPhone', mask: '(###) ###-####', rules: 'required|phone' },
    { label: 'Amount of Open Loans', fieldKey: 'amountOfOpenLoans', format: 'currency', inputType: 'number', rules: 'required|currency' },
    { label: 'Number of Open Loans', fieldKey: 'numberOfOpenLoans', inputType: 'number', rules: 'required|positiveInteger' },
    { label: 'Account Balance', fieldKey: 'accountBalance', format: 'currency', inputType: 'number', rules: 'required|currency' }
  ]
}
export default BANK
